import Unit from '@models/building/Unit'
import Roomtypeat from '@models/helpers/RoomtypeAt'
import Unitairvolume from '@models/airvolumes/Unitairvolume'

import store from '../../store'

import din18017Calculation from '@services/calculations/din18017Calculation'
import din1946Calculation from '@services/calculations/din1946Calculation'
import {calculateWrgAirvolumes} from '@services/calculations/wrgCalculation'
import combiCalculation from '@services/calculations/combiCalculation'
import Configuration from "@models/project/Configuration";

import Roomairvolume from "@models/airvolumes/Roomairvolume";
import Systemselection from "@models/airvolumes/Systemselection";
import Installation from "@models/airvolumes/Installation";
import {calculateValves} from "@services/calculations/valveCalculation";
import RoomtypesHasOperationmodesHasAirvolumeAt from "@models/helpers/RoomtypesHasOperationmodesHasAirvolume";
import RoomltmsHasOperationmodeAt from "@models/helpers/RoomltmsHasOperationmodeAt";
import Room from "@models/building/Room";

import atNorm6036 from '@services/calculations/atNorm6036';

const defaultsAt = {
  supplyRooms: 0,
  exhaustRooms: 0,
  peopleNumber: 0
}

export default {
  calculate(unitId = null, reset = false) {
    let normsId = Configuration.query().with(['project']).first().norms_id;
    if (normsId == 1) {
      let units
      if (unitId !== null) {
        units = Unit.query().where('id', unitId).with(['airvolume', 'rooms']).get()
      } else {
        units = Unit.query().with(['airvolume', 'rooms']).get()
      }

      units.forEach((unit) => {
        if (unit.rooms.length == 0) return
        if (!reset && !unit.airvolumeUpdate) return
        this.basicCalculations(unit)

        // DIN 18017 = ltm 1, 7 | DIN 1946 = ltm 2 | WRG = ltm 3, 4 | Kombi = ltm 5,6
        switch (parseInt(unit.ventilationMeasure)) {
          case 1:
          case 7:
            din18017Calculation.calculate(unit.id)
            break
          case 2:
            din1946Calculation.calculate(unit.id)
            break
          case 3:
          case 4:
            calculateWrgAirvolumes(unit.id)
            break
          case 5:
          case 6:
            combiCalculation.calculate(unit.id)
            break
        }

        if (unit.airvolumeUpdate == 'loaded') {
          Unit.update({
            where: unit.id,
            data: {
              airvolumeUpdate: false,
            },
          })
        } else {
          Unit.update({
            where: unit.id,
            data: {
              articleUpdate: true,
              equipmentUpdate: true,
              airvolumeUpdate: false,
            },
          })
        }
      })
      return
    } else {
      const units = unitId !== null ?
        Unit.query().where('id', unitId).with(['airvolume', 'rooms.airvolume']).get()
        : Unit.query().with(['airvolume', 'rooms.airvolume', 'systemselection', 'installation']).get()


      units.forEach((unit) => {

        if (unit.rooms.length == 0) return
        //if (!reset && !unit.airvolumeUpdate) return

        // set default
        this.setAtDefaults(unit)

        /*                defaultsAt.peopleNumber = 0
                        if (unit.peopleNumber > 0) {
                            defaultsAt.peopleNumber = unit.peopleNumber
                        } else {
                            unit.rooms.forEach(room => {
                                const roomtype = Roomtypeat.query().where('id', room.type).first()
                                defaultsAt.peopleNumber += roomtype.people_number;
                            })
                        }*/

        if (parseInt(unit.ventilationMeasure) != 1) {
          if (unit.peopleNumber <= 0 || isNaN(unit.peopleNumber) || unit.peopleNumber === null) {
            unit.peopleNumber = 0
            unit.rooms.forEach(room => {
              const roomtype = Roomtypeat.query().where('id', room.type).first()
              unit.peopleNumber += roomtype.people_number;
            })
          }


          if (!unit.airvolume.manually) {
            this.calcDefaultUnitAirvolume(unit)

            if (unit.airvolume.totalExhaustAir < unit.airvolume.totalSupplyAir) {
              this.checkAirvolumeAt(unit)
            }

            unit.rooms.forEach((room) => {
              this.setDefaultOperationmodeAt(room)
              room.airvolume.doorLeaf = 86;
            })
          } else {
            unit.rooms.forEach(room => {
              if (room.airType == 1) {
                unit.airvolume.totalExhaustAir += room.airvolume.airvolume
              } else {
                unit.airvolume.totalSupplyAir += room.airvolume.airvolume
              }
            })
          }

          this.calculateTotalOperationmodeAirAt(unit);
          this.calculateUld(unit);

          unit.articleUpdate = true
          unit.equipmentUpdate = true
          unit.airvolumeUpdate = false

          unit.airvolume.nl = unit.airvolume.totalSupplyAir
          unit.airvolume.exhaustAir = unit.airvolume.totalExhaustAir
          // unit.airvolume.totalFrZu = 999;
          Unitairvolume.insertOrUpdate({data: [unit.airvolume]});
          Unit.insertOrUpdate({
            data: [unit]
          })
          calculateValves(unit.id, true, 'valves');
        } else {
          atNorm6036.calculate(unit.id)
        }
      });

    }
  },

  setAtDefaults(unit) {

    if (unit.airvolume == null) {
      unit.airvolume = new Unitairvolume({unitId: unit.id})
      Unitairvolume.insert({data: [unit.airvolume]});
    }

    if (unit.systemselection == null) {
      unit.systemselection = new Systemselection({
        unitId: unit.id,
        deviceLevel: unit.level,
      })

      Systemselection.insert({data: [unit.systemselection]});
    }
    if (unit.installation == null) {
      unit.installation = new Installation({
        unitId: unit.id,
        storey: unit.storey,
      })

      Installation.insert({data: [unit.installation]});
    }

    unit.airvolume.totalSupplyAir = 0
    unit.airvolume.totalExhaustAir = 0
    defaultsAt.supplyRooms = 0
    defaultsAt.exhaustRooms = 0

    // set people Number by unit/roomtype
    unit.rooms.forEach((room) => {
      if (room.airvolume == null) {
        room.airvolume = new Roomairvolume({roomId: room.id});
        Roomairvolume.insert({data: [room.airvolume]});
      }
    })
    this.basicCalculations(unit)
  },

  calcDefaultUnitAirvolume(unit) {
    unit.rooms.forEach((room) => {
      const roomtypeat = Roomtypeat.query().where('id', room.type).first()
      if (roomtypeat.air_type === 2) { // then it's zuluft room
        unit.airvolume.totalSupplyAir += this.airVolumeRoom(unit, roomtypeat, room);
        defaultsAt.supplyRooms++;
      } else {
        unit.airvolume.totalExhaustAir += this.airVolumeRoom(unit, roomtypeat, room);
        if (roomtypeat.qty_balance === 1) {
          defaultsAt.exhaustRooms++;
        }
      }
    })
  },

  airVolumeRoom(unit, roomtypeat, room) {
    if (unit.co2voc) {
      room.airvolume.airvolume = roomtypeat.air_volume_with_sensor
    } else {
      room.airvolume.airvolume = roomtypeat.air_volume_without_sensor
    }

    if (roomtypeat.multiple_people < 1) {
      return room.airvolume.airvolume
    }

    if (roomtypeat.id === 34) {
      if (unit.peopleNumber <= 2) {
        room.airvolume.airvolume = 30 * unit.peopleNumber;
      } else {
        room.airvolume.airvolume = 15 * unit.peopleNumber;
      }
      return room.airvolume.airvolume
    }

    room.airvolume.airvolume = room.airvolume.airvolume * roomtypeat.multiple_people * unit.peopleNumber
    if (roomtypeat.id === 35) {
      if (room.airvolume.airvolume < 30) {
        room.airvolume.airvolume = 30;
      }
    }

    return room.airvolume.airvolume;
  },

  checkAirvolumeAt(unit) {
    let differenceVolume = unit.airvolume.totalSupplyAir - unit.airvolume.totalExhaustAir

    if (differenceVolume > 0 && defaultsAt.exhaustRooms > 0) {
      differenceVolume = Math.round(differenceVolume / defaultsAt.exhaustRooms);
      unit.rooms.forEach((room) => {
        const roomtypeat = Roomtypeat.query().where('id', room.type).get()[0]

        if (roomtypeat.qty_balance === 1) {
          room.airvolume.airvolume += differenceVolume
          room.airvolume.nlAb += differenceVolume;
          unit.airvolume.totalExhaustAir += differenceVolume;
        }
      })
    }
  },

  calculateUld(unit) {
    let f_uld = 3.1;
    let p_uld = 1.5;
    if (unit.overflowSeal == 1) var k_dichtung = 25;
    if (unit.overflowSeal == 0) var k_dichtung = 0;

    unit.rooms.forEach((room) => {
      let airvolume = 0;
      if (room.airvolume.operationmodeAirvolume > 0) airvolume = RoomtypesHasOperationmodesHasAirvolumeAt.find(room.airvolume.operationmodeAirvolume).duration_airvolume;
      if (airvolume <= 0 || airvolume == null) airvolume = room.airvolume.airvolume;
      if (airvolume <= 0 || airvolume == null) {
        room.airvolume.uld = 0;
        return;
      }
      room.airvolume.uld = +parseFloat((f_uld * airvolume) / Math.pow(p_uld, 0.5) - k_dichtung).toFixed(0);
    });
  },

  setDefaultOperationmodeAt(room) {
    if (room.airvolume.operationmode == null || room.airvolume.operationmode <= 0 || !RoomltmsHasOperationmodeAt.query().where('roomltms_id', room.ventilationMeasure).where('operationmodes_id', room.airvolume.operationmode).exists()) {
      var operationmode = RoomltmsHasOperationmodeAt.query().where('roomltms_id', room.ventilationMeasure).where('default', 1).first()
      room.airvolume.operationmode = operationmode.operationmodes_id
    }
    if (room.airvolume.operationmodeAirvolume == null || room.airvolume.operationmodeAirvolume <= 0) {
      var operationmodeAirvolume = RoomtypesHasOperationmodesHasAirvolumeAt.query().where('operationmodes_id', room.airvolume.operationmode).where('roomtypes_id', room.type).where('window', +room.window).where('default', true).first()
      if (operationmodeAirvolume != undefined || operationmodeAirvolume != null) {
        room.airvolume.operationmodeAirvolume = operationmodeAirvolume.id
      }
    }
  },

  calculateTotalOperationmodeAirAt(unit) {
    unit.airvolume.totalNeedAir = 0
    unit.airvolume.totalDurationAir = 0
    unit.rooms.forEach(
      function (room, index) {
        if (room.airvolume.operationmodeAirvolume == null || room.airvolume.operationmodeAirvolume <= 0 || !(room.ventilationMeasure == 1 || room.ventilationMeasure == 6)) return
        var operationmodeAirvolume = RoomtypesHasOperationmodesHasAirvolumeAt.find(room.airvolume.operationmodeAirvolume)
        unit.airvolume.totalNeedAir += operationmodeAirvolume.need_airvolume
        unit.airvolume.totalDurationAir += operationmodeAirvolume.duration_airvolume
      }.bind(this)
    )
  },

  basicCalculations(unit) {
    if (unit.airvolume == null) {
      unit.airvolume = new Unitairvolume({unitId: unit.id})
    }

    unit.airvolume.space = 0
    unit.airvolume.height = 0
    unit.airvolume.volume = 0

    unit.rooms.forEach(
      function (room) {
        unit.airvolume.space += room.space
        unit.airvolume.height += room.height
      }.bind(this)
    )

    unit.airvolume.height = unit.airvolume.height / unit.rooms.length
    unit.airvolume.volume = +parseFloat(unit.airvolume.space * unit.airvolume.height).toFixed(2)

    if (unit.space != +parseFloat(unit.airvolume.space).toFixed(2) || unit.height != +parseFloat(unit.airvolume.height).toFixed(2)) {
      unit.space = +parseFloat(unit.airvolume.space).toFixed(2)
      unit.height = +parseFloat(unit.airvolume.height).toFixed(2)
      unit.volume = +parseFloat(unit.airvolume.volume).toFixed(2)

      unit.preCalculations()

      Unit.update({
        where: unit.id,
        data: unit,
      })

      store.dispatch('alert/setAlert', {type: 'success', message: Lang('lang.kwl.alert.unit_space_updated')})
    }
  },

  checkMoisureProtection(unit) {
    if (unit.airvolumes.total_duration_air <= unit.airvolumes.fl) return false
    return true
  },

}
